import EventEmitter from 'events'

import store from '@/store/index'

class AuthService extends EventEmitter {
  logOut() {
    window.localStorage.clear();
    window.location.reload();
  }

  isAuthenticated() {
    return store.state.auth.accessToken !== null;
  }

  getToken() {
    if (!store.state.auth.accessToken) {
      this.logOut();
      return null;
    }
    return store.state.auth.accessToken;
  }

  isGodAdmin() {
    const tokenData = this.getToken().split('.');

    const data = Buffer.from(tokenData[1], 'base64').toString('utf8');

    const parsedData = JSON.parse(data);

    if (
      parsedData &&
      parsedData.client_id &&
      parsedData.client_id.includes('god_admin_')
    ) {
      return true;
    }

    return false;
  }
}

export default new AuthService()
